// Das Band „offene Fragen“ in Signalfarbe Lime (E3, S6; Gernots Entscheidung
// 2, 21.10.2026: kein Web-Push – „die offenen Fragen stehen oben in der App,
// sichtbar, nicht zu übersehen … ebenso im CRM“). Eine Form, drei Stellen:
//   - oben auf JEDER Seite des CRM, unter dem Kopf (rahmen.tsx, `Seite`):
//     „3 offene Fragen – ansehen und antworten“ → #/fragen – auch für die
//     Montage, die sonst wenig im CRM hat;
//   - oben in der Freigabe: „2 offene Fragen an dieser Besichtigung“ → zur
//     ersten (Aufnahme.tsx);
//   - oben in der Akte: „… an diesem Projekt“ → zur ersten (Akte.tsx).
// Zeigt eine Seite selbst Fragen (Freigabe, Akte), nennt das Band oben nur
// die übrigen („1 weitere …“) – sonst stünde dieselbe Frage doppelt da.
// Das Zeichen links ist dasselbe wie am Knopf „Frage stellen“ und an der
// Marke „1 offene Frage“ (zeichen.tsx) – ein Muster für alle Fragen.

import type { ReactNode } from "react";
import { Ikon } from "@happy-energy/oberflaeche";
import { wannZeigen } from "../anzeige.ts";
import { aeltesteZuerst, ausserHier, bandText, ortText } from "./fragen.ts";
import { useOffeneFragen } from "./offene.tsx";
import { FrageZeichen } from "./zeichen.tsx";
import "./fragen.css";

/** Das Band selbst: mit `href` ganz ein Link, sonst mit einem Knopf rechts. */
export function FragenBand({ titel, unter, href, knopf }: { titel: string; unter?: ReactNode; href?: string; knopf?: { name: string; los: () => void } }) {
  const inhalt = (
    <>
      <FrageZeichen gross />
      <span className="crm-fragen-band-wort">
        <b>{titel}</b>
        {unter && <span>{unter}</span>}
      </span>
    </>
  );
  if (href) {
    return (
      <a className="crm-fragen-band" href={href}>
        {inhalt}
        <Ikon name="rechts" />
      </a>
    );
  }
  return (
    <div className="crm-fragen-band" role="status">
      {inhalt}
      {knopf && (
        <button type="button" className="crm-knopf dunkel klein" onClick={knopf.los}>
          {knopf.name} <Ikon name="rechts" groesse="k" />
        </button>
      )}
    </div>
  );
}

/**
 * Das Band oben auf jeder Seite – alle offenen Fragen, die der Angemeldete
 * sehen darf (der Verkauf: an seinen Besichtigungen). `hier`: die
 * Besichtigungen, deren Fragen die Seite selbst zeigt.
 */
export function OffeneFragenBand({ hier }: { hier?: readonly string[] }) {
  const { fragen } = useOffeneFragen();
  if (!fragen) return null;
  const uebrige = aeltesteZuerst(ausserHier(fragen, hier));
  const aelteste = uebrige[0];
  if (!aelteste) return null;
  const weitere = uebrige.length < fragen.length;
  return (
    <FragenBand
      titel={bandText(uebrige.length, weitere)}
      unter={`Die älteste wartet seit ${wannZeigen(aelteste.gestelltAm)} – ${aelteste.kontext.kundeName}, ${aelteste.kontext.ort}, ${ortText(aelteste.bezug.tabelle, aelteste.kontext.stationNr)}`}
      href="#/fragen"
    />
  );
}
